var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeSeller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69736 4.18257C8.14144 3.88382 8.58552 3.88382 9.0296 4.18257L11.6941 5.82573L16.875 0H10.9539L6.66118 4.78008L7.69736 4.18257Z",
    fill: "#5669E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69737 4.18257C8.14145 3.88382 8.58553 3.88382 9.02961 4.18257L10.5099 5.07884L6.06908 0H0L5.0329 5.67635L7.69737 4.18257Z",
    fill: "#011397"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40438 7.76763C3.10832 8.06638 2.81227 8.21576 2.81227 8.96265V14.0415C2.81227 14.4896 3.10832 14.9378 3.70043 15.2365L7.84517 17.7759C8.28925 18.0747 8.73332 18.0747 9.1774 17.7759L11.9899 15.9834L5.03267 6.72198L3.40438 7.76763Z",
    fill: "#C29D46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1741 7.76757L9.02939 5.22816C8.58532 4.9294 8.14124 4.9294 7.54913 5.22816L5.03268 6.72193L11.9899 15.9833L13.3222 15.2365C13.7662 14.9377 13.9143 14.6389 13.9143 14.0414V8.9626C13.9143 8.21571 13.6182 8.06633 13.1741 7.76757Z",
    fill: "#EFC259"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeSeller);
export default __webpack_public_path__ + "static/media/volume-seller.6cafebcf90bd131568d21873417e4945.svg";
export { ForwardRef as ReactComponent };